// extracted by mini-css-extract-plugin
module.exports = {"newButton":"FileUpload_newButton__3Ern9","detailView":"FileUpload_detailView__21rHw","error":"FileUpload_error__1i_i9","buttonWrap":"FileUpload_buttonWrap__31Usg"};